<template>
  <div class="h-full w-full">
    <div
      v-if="!post_onboard_broker_channels_have_loaded"
      class="flex h-screen w-full items-center justify-center"
    >
      <div
        class="inner-container flex flex-col items-start justify-center p-8 py-16"
      >
        <div class="mx-auto h-16 w-16 text-center">
          <!-- <img
                      class="w-full relative -top-2px loading"
                      src="@/assets/loading-v2-yellow.svg"
                      alt=""
                  /> -->
          <svg
            class="-top-2px loading relative w-full text-yellow-500"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3311 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76755 16.0133 4.00519 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02236C11.3065 4.70379 13.6266 4 16 4"
              stroke="currentColor"
              stroke-width="3"
            />
            <path
              d="M16 1V7L20 4L16 1Z"
              fill="currentColor"
            />
            <path
              d="M22.4895 7.161C24.4444 8.50678 25.9564 10.402 26.8342 12.6071"
              stroke="currentColor"
              stroke-width="3"
            />
          </svg>
        </div>
        <div class="mt-4 text-dark-gray">
          <h3 class="text-center text-xl">Loading...</h3>
        </div>
        <!-- <div class="mt-4 h-32 text-center mx-auto">
                  <div class="text-gray-over-dark text-sm text-center w-full mx-auto">{{ this.loadingMessage }}</div>
              </div> -->
      </div>
    </div>
    <div
      v-else-if="post_onboard_broker_connect_channels?.length > 0"
      class="welcome-container relative flex h-screen w-screen items-center object-fill"
    >
      <div
        class="absolute hidden h-screen w-1/2 items-center overflow-hidden bg-dark-gray lg:flex"
      >
        <div
          class="welcome-container-dark absolute h-screen w-screen object-fill"
        />
      </div>

      <div
        class="max-h-welcome-container z-10 grid h-full w-full grid-cols-1 lg:grid-cols-2"
      >
        <div
          class="col-span-1 flex h-full w-full flex-col items-center justify-center"
        >
          <div class="max-w-sm">
            <h1 class="text-5xl text-yellow-500">Thank You!</h1>
            <p class="my-5 whitespace-nowrap text-lg lg:text-light-gray">
              Your identity is secured. We'll see you soon.
            </p>
            <button-main
              variant="primary"
              @click="redirectToCarrierPortal"
            >
              Go to Carrier Portal
            </button-main>
            <button-main
              v-if="isJbhCompanyIdInUrl"
              variant="primary"
              sizes="md"
              class="mt-3"
              @click="redirectToJBHunt"
            >
              Navigate here to J.B. Hunt to complete Sign up or Log in
            </button-main>
          </div>
        </div>
        <div
          class="col-span-1 mt-4 flex h-full w-full flex-col items-center justify-start px-8 lg:mt-0 lg:justify-center"
        >
          <div
            class="m-auto flex w-full max-w-md flex-col rounded-lg border border-light-gray bg-white px-8 py-4 text-body-color shadow-md"
          >
            <h4 class="mb-8 mt-4 text-left text-lg text-dark-gray sm:mt-2">
              Connect your systems with {{ broker_info?.legal_name }}.
            </h4>
            <div class="mb-3 flex flex-col gap-4">
              <div
                v-for="(
                  integration, index
                ) in post_onboard_broker_connect_channels"
                :key="`${integration.name}-${index}`"
                class="integration-btn cursor-pointer"
                style="padding-left: 10px"
                :class="{
                  'connected-integration': carrier_integrations.includes(
                    integration.name
                  ),
                }"
                :style="
                  checkShowOnThankYouPage(integration) == false
                    ? 'display: none'
                    : ''
                "
                @click="setSelected(integration)"
              >
                <img
                  v-if="
                    integration.is_type === 'ascendtms' &&
                    checkShowOnThankYouPage(integration)
                  "
                  src="@/assets/integrations/ascend.svg"
                  alt="AscendTMS logo"
                />
                <img
                  v-if="
                    integration.is_type === 'mcleod' &&
                    checkShowOnThankYouPage(integration)
                  "
                  src="@/assets/integrations/McLeod.png"
                  alt="McLeod logo"
                  class="-ml-2 mt-1"
                  style="width: 120px; height: 48px"
                />
                <img
                  v-if="
                    integration.is_type === 'smarthop' &&
                    checkShowOnThankYouPage(integration)
                  "
                  src="@/assets/integrations/smarthop.svg"
                  alt="Smarthop logo"
                />
                <img
                  v-if="
                    integration.is_type === 'macropoint' &&
                    checkShowOnThankYouPage(integration)
                  "
                  src="@/assets/macropoint.png"
                  alt="Macropoint logo"
                  class="h-11 w-20"
                />
                <img
                  v-if="
                    integration.is_type === 'fourkites' &&
                    checkShowOnThankYouPage(integration)
                  "
                  src="@/assets/integrations/fourkites.svg"
                  alt="Fourkites logo"
                />
                <img
                  v-if="
                    integration.is_type === 'keeptruckin' &&
                    checkShowOnThankYouPage(integration)
                  "
                  src="@/assets/integrations/keeptruckin.svg"
                  alt="KeepTruckin logo"
                />
                <img
                  v-if="
                    integration.is_type === 'motive' &&
                    checkShowOnThankYouPage(integration)
                  "
                  src="@/assets/integrations/motive.svg"
                  alt="Motive logo"
                  style="height: 30px"
                />
                <img
                  v-if="
                    integration.is_type === 'samsara' &&
                    checkShowOnThankYouPage(integration)
                  "
                  src="@/assets/integrations/samsara.svg"
                  alt="Samsara logo"
                  style="height: 30px"
                />
                <img
                  v-if="
                    integration.is_type === 'trucker_tools' &&
                    checkShowOnThankYouPage(integration)
                  "
                  src="@/assets/integrations/trucker_tools_logo.png"
                  alt="Trucker Tools logo"
                  style="height: 20px"
                />

                <div class="flex px-4">
                  <p
                    class="mr-2"
                    :class="
                      connect_subscriptions_by_name.includes(integration.name)
                        ? 'text-yellow-500'
                        : 'text-gray-over-dark'
                    "
                  >
                    {{
                      connect_subscriptions_by_name.includes(integration.name)
                        ? 'Connected'
                        : 'Connect'
                    }}
                  </p>
                  <img
                    v-if="
                      connect_subscriptions_by_name.includes(integration.name)
                    "
                    src="@/assets/yellow-verified.svg"
                    alt="right-triangle polygon"
                  />
                  <img
                    v-else
                    src="@/assets/right-triangle.svg"
                    alt="right-triangle polygon"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="isActiveTruckerTool"
              class="mt-4 w-full"
            >
              <elds-connected />
            </div>
          </div>
        </div>
      </div>
      <footer-main />
    </div>
    <div
      v-else
      class="welcome-container flex h-screen items-center object-fill p-10 md:p-5"
    >
      <div
        class="max-h-welcome-container m-auto flex h-full max-w-sm flex-col justify-between"
      >
        <div class="flex h-full w-full flex-col items-center justify-center">
          <div class="">
            <h1 class="text-5xl text-yellow-500">Thank You!</h1>
            <p class="my-5 whitespace-nowrap text-lg">
              Your identity is secured. We'll see you soon.
            </p>
            <div class="flex flex-col gap-3">
              <button-main
                variant="primary"
                @click="redirectToCarrierPortal"
              >
                Go to Carrier Portal
              </button-main>
              <button-main
                v-if="isJbhCompanyIdInUrl"
                variant="primary"
                sizes="md"
                @click="redirectToJBHunt"
              >
                <span class="text-xs"
                  >Navigate here to J.B. Hunt to complete Sign up or Log
                  in</span
                >
              </button-main>
            </div>
          </div>
          <footer-main />
        </div>
      </div>
    </div>
    <login-modal
      v-if="showModal"
      :visible="showModal"
      :integration="selected"
      :update-integrations="updateIntegrations"
      @close="onCloseModal"
    />
  </div>
</template>

<script>
import ButtonMain from '@/components/Button.vue';
import FooterMain from '@/components/Footer.vue';
import IntegrationLoginModal from '@/components/modals/IntegrationLoginModal.vue';
import EldsConnected from '@/components/steps/Integrations/TruckerTools/EldsConnected.vue';
import { ref } from 'vue';
export default {
  name: 'Thank You - Page',
  components: {
    ButtonMain,
    FooterMain,
    'login-modal': IntegrationLoginModal,
    'elds-connected': EldsConnected,
  },
  setup(_, { emit }) {
    const showModal = ref(false);

    const openModal = () => {
      showModal.value = true;
    };
    const onCloseModal = () => {
      showModal.value = false;
    };

    const emitExitModal = () => {
      emit('exit-modal');
    };

    return {
      showModal,
      openModal,
      onCloseModal,
      emitExitModal,
    };
  },
  data() {
    return {
      selected: '',
    };
  },
  computed: {
    isJbhCompanyIdInUrl() {
      if (
        this.$store.state.users.featureFlags?.disable_chr_thank_you_button
          ?.enabled
      )
        return false;

      const companyIdFromUrl = this.$route.query.company_id;
      return companyIdFromUrl === this.getJbhCompanyId;
    },
    getJbhCompanyId() {
      return import.meta.env.VITE_JBH;
    },
    post_onboard_broker_channels_have_loaded() {
      return this.$store.state.onboardingPacket
        ?.post_onboard_broker_channels_have_loaded;
    },
    isActiveTruckerTool() {
      return this.$store.state.integrations?.truckerTools?.isActive;
    },
    issuer_id() {
      return this.$store.state.carriers?.carrierData?.connection?.issuer_id;
    },
    post_onboard_broker_connect_channels() {
      return this.$store.state.onboardingPacket?.post_onboard_broker_channels;
    },
    broker_info() {
      return this.$store.state.carriers.carrierData?.connection?.issuer;
    },
    carrier_integrations() {
      return this.$store.state.carriers.carrierData?.integrations?.systems;
    },
    connect_subscriptions() {
      return this.$store.state.onboardingPacket?.connect_subscriptions;
    },
    connect_subscriptions_by_name() {
      let returnVal = [];
      if (this.connect_subscriptions) {
        this.connect_subscriptions.forEach(function (el) {
          returnVal.push(el?.channel?.name);
        });
      }
      return returnVal;
    },
  },
  watch: {
    issuer_id: {
      handler: function (val) {
        let self = this;
        if (val > 0) {
          self.$store.dispatch(
            'onboardingPacket/getPostOnboardBrokerConnectChannels',
            val
          );
        }
      },
    },
  },
  beforeCreate() {
    // In case this value has been set to true earlier in the flow, reset it to false
    this.$store.commit(
      'onboardingPacket/setPostOnboardBrokerConnectChannelsHaveLoaded',
      false
    );
  },
  created() {
    this.$store.dispatch('onboardingPacket/getLatestCompletedOnboardingPacket');
  },
  mounted() {
    this.$store.commit('errors/setShowErrorBanner', false);
  },
  methods: {
    async setSelected(item) {
      //Trucker tools need to render another additionals screens the ID is 25,
      if (item?.is_type === 'trucker_tools') {
        await this.$store.dispatch('integrations/getCarrierElds', item.id);
        this.$store.commit('integrations/setActiveTruckerTools', true);
        this.$store.commit('integrations/setTruckerToolChannelId', item.id);
      } else {
        this.selected = item?.name;
        let thisPage = window.location.href;
        window.location.href = `${item.initialization_url}?redirect_url=${thisPage}`;
      }
    },
    updateNestedField(path, value) {
      this.$store.commit('updateNestedField', { path, value });
    },
    updateIntegrations(path, value) {
      let newArray =
        this.$store.state.carriers.carrierData.integrations.systems.indexOf(
          value
        ) === -1
          ? [
              ...this.$store.state.carriers.carrierData.integrations.systems,
              value,
            ]
          : this.$store.state.carriers.carrierData.integrations.systems;
      this.updateNestedField(path, newArray);
    },
    checkShowOnThankYouPage(integration) {
      let is_types =
        this.$store.state.onboardingPacket
          ?.post_onboard_broker_channel_is_types;
      if (is_types.includes(integration?.is_type)) {
        return !integration?.is_shown_in_integrations_step;
      }
      return false;
    },
    redirectToJBHunt() {
      const url =
        'https://sso.jbhunt.com/auth/realms/security360/protocol/openid-connect/registrations?response_type=code&client_id=carrier&scope=openid&signup_flow=carrier&state=b59c3766-b047-4fa5-b052-343b0bfdead3&redirect_uri=https%3A%2F%2Fscm.jbhunt.com%2Fcarrier%3Fidp_krb%3Dfalse&utm_source=highway&utm_medium=signup&utm_campaign=highway_signup';
      window.open(url, '_blank');
    },
    redirectToCarrierPortal() {
      this.$router.push({
        name: 'Carrier Dashboard',
      });
    },
  },
};
</script>

<style scoped>
.welcome-container {
  background-image: url('@/assets/highway-h.svg'),
    linear-gradient(
      218.91deg,
      rgba(96, 95, 128, 0.3) -91.54%,
      rgba(96, 95, 128, 0) 85.24%
    );
  /* background-image: url("@/assets/highway-h.svg"); */
  background-size: cover;
  background-position-x: center;
  background-position-y: 100%;
}

.welcome-container-dark {
  background-image: url('@/assets/highway-h-dark.svg'),
    linear-gradient(
      218.91deg,
      rgba(96, 95, 128, 0) -91.54%,
      rgba(96, 95, 128, 0) 85.24%
    );
  background-size: cover;
  background-position-x: center;
  background-position-y: 100%;
}

@media (min-width: 1024px) {
  .welcome-container {
    background-image: url('@/assets/highway-h.svg'),
      linear-gradient(
        218.91deg,
        rgba(96, 95, 128, 0.3) -91.54%,
        rgba(96, 95, 128, 0) 85.24%
      );
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .welcome-container-dark {
    background-image: url('@/assets/highway-h-dark.svg'),
      linear-gradient(
        218.91deg,
        rgba(96, 95, 128, 0) -91.54%,
        rgba(96, 95, 128, 0) 85.24%
      );
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}

.max-h-welcome-container {
  max-height: 39rem;
}

.broker-logo {
  margin: 0 auto;
  margin-bottom: 1.25rem;
  max-width: 60%;
  max-height: 60px;
}
</style>
